import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import SearchButton from '../search/SearchButton';
import SearchDropdown from '../search/SearchDropdown';
import NotificationBell from '../notifications/NotificationBell';
import pixelIcon from '../../assets/icons/svg/pixel_icon.svg';
import ExitIcon from '../../assets/icons/ExitIcon';
import SunIcon from '../../assets/icons/SunIcon';
import MoonIcon from '../../assets/icons/MoonIcon';
import './Header.css';

const Header = ({ onLoginClick }) => {
    const { user, logout } = useAuth();
    const { theme, toggleTheme } = useTheme();
    const { t } = useTranslation();
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    return (
        <header className="header">
            <div className="header__inner">
            <Link to="/" className="header-logo">
                <img src={pixelIcon} alt="Pixel" className="header-logo__icon" />
                <span className="header-logo__text">PIXEL</span>
            </Link>

            <div className="header-actions">
                <div className="header-search-wrapper">
                    <SearchButton onClick={() => setIsSearchOpen(!isSearchOpen)} />
                    {isSearchOpen && <SearchDropdown onClose={() => setIsSearchOpen(false)} />}
                </div>

                {user && (
                    <Link to="/create-post" className="create-post-button">
                        {t('header.create_post')}
                    </Link>
                )}

                <NotificationBell variant="desktop" />

                <button className="theme-toggle-button" onClick={toggleTheme} aria-label={t('header.toggle_theme')}>
                    {theme === 'dark' ? <SunIcon size={20} /> : <MoonIcon size={20} />}
                </button>

                {user ? (
                    <div className="user-info">
                    <Link to="/profile" className="user-info__link">
                    {user.avatar ? (
                    <img
                    src={user.avatar}
                    alt={user.displayName ?? user.username}
                    className="user-avatar"
                    />
                    ) : (
                        <div className="user-avatar">
                        {(user.displayName ?? user.username).charAt(0).toUpperCase()}
                    </div>
                    )}
                    <span className="user-info__name">{user.displayName ?? user.username}</span>
                    </Link>
                        <button className="logout-button" data-testid="logout-button" onClick={logout} aria-label={t('header.logout')}>
                            <ExitIcon className="login-button__icon" />
                        </button>
                    </div>
                ) : (
                    <button className="login-button" data-testid="login-button" onClick={onLoginClick}>
                        <ExitIcon className="login-button__icon" />
                        {t('header.login')}
                    </button>
                )}
            </div>
            <NotificationBell variant="mobile" />
            </div>
        </header>
    );
};

export default Header;
